// Mock data

export const carBrands = [
  { id: 1, name: 'RENAULT', popular: true },
  { id: 2, name: 'PEUGEOT', popular: true },
  { id: 3, name: 'VOLKSWAGEN', popular: true },
  { id: 4, name: 'BMW', popular: true },
  { id: 5, name: 'CITROËN', popular: true },
  { id: 6, name: 'AUDI', popular: true },
  { id: 7, name: 'MERCEDES-BENZ', popular: true },
  { id: 8, name: 'FORD', popular: true },
  { id: 9, name: 'OPEL', popular: true },
  { id: 10, name: 'FIAT', popular: true },
  { id: 11, name: 'TOYOTA', popular: false },
  { id: 12, name: 'HONDA', popular: false },
  { id: 13, name: 'NISSAN', popular: false },
  { id: 14, name: 'MAZDA', popular: false },
  { id: 15, name: 'HYUNDAI', popular: false },
  { id: 16, name: 'KIA', popular: false },
  { id: 17, name: 'VOLVO', popular: false },
  { id: 18, name: 'SKODA', popular: false },
  { id: 19, name: 'SEAT', popular: false },
  { id: 20, name: 'DACIA', popular: false },
];

export const carModels = {
  RENAULT: ['Clio', 'Megane', 'Captur', 'Scenic', 'Kadjar', 'Twingo', 'Talisman', 'Koleos'],
  PEUGEOT: ['208', '308', '3008', '2008', '5008', '508', '108', 'Partner'],
  VOLKSWAGEN: ['Golf', 'Polo', 'Passat', 'Tiguan', 'T-Roc', 'Touran', 'Arteon', 'ID.3'],
  BMW: ['Série 1', 'Série 3', 'Série 5', 'X1', 'X3', 'X5', 'Série 2', 'Z4'],
  'CITROËN': ['C3', 'C4', 'C5', 'Berlingo', 'C3 Aircross', 'C5 Aircross', 'C1', 'SpaceTourer'],
  AUDI: ['A3', 'A4', 'A6', 'Q3', 'Q5', 'Q7', 'A1', 'TT'],
  'MERCEDES-BENZ': ['Classe A', 'Classe C', 'Classe E', 'GLA', 'GLC', 'GLE', 'Classe B', 'CLA'],
  FORD: ['Fiesta', 'Focus', 'Puma', 'Kuga', 'Mondeo', 'EcoSport', 'Mustang', 'Ranger'],
  OPEL: ['Corsa', 'Astra', 'Mokka', 'Crossland', 'Grandland', 'Insignia', 'Combo', 'Zafira'],
  FIAT: ['500', 'Panda', 'Tipo', '500X', '500L', 'Doblo', 'Ducato', 'Punto'],
};

export const categories = [
  {
    id: 1,
    name: 'Pneus et jantes',
    image: 'https://scdn.autodoc.de/catalog/categories/600x600/tyres_wheels.png',
    subcategories: ['Pneus été', 'Pneus hiver', 'Pneus 4 saisons', 'Jantes alu', 'Jantes en tôle']
  },
  {
    id: 2,
    name: 'Frein',
    image: 'https://scdn.autodoc.de/catalog/categories/600x600/10106.png',
    subcategories: ['Disque de frein', 'Plaquette de frein', 'Étrier de frein', 'Kit de frein arrière']
  },
  {
    id: 3,
    name: 'Moteur',
    image: 'https://scdn.autodoc.de/catalog/categories/600x600/10102.png',
    subcategories: ['Kit de distribution + pompe à eau', 'Courroie d\'alternateur', 'Turbo', 'Support moteur']
  },
  {
    id: 4,
    name: 'Courroies, chaînes, galets',
    image: 'https://scdn.autodoc.de/catalog/categories/600x600/10116.png',
    subcategories: ['Kit de distribution', 'Kit de courroie', 'Courroie de distribution', 'Kit chaîne']
  },
  {
    id: 5,
    name: 'Embrayage',
    image: 'https://scdn.autodoc.de/catalog/categories/600x600/10150.png',
    subcategories: ['Kit d\'embrayage', 'Volant moteur']
  },
  {
    id: 6,
    name: 'Amortissement',
    image: 'https://scdn.autodoc.de/catalog/categories/600x600/10111.png',
    subcategories: ['Amortisseur', 'Coupelle d\'amortisseur']
  },
  {
    id: 7,
    name: 'Suspension',
    image: 'https://scdn.autodoc.de/catalog/categories/600x600/10113.png',
    subcategories: ['Bras de suspension', 'Moyeu de roue', 'Biellette de barre stabilisatrice']
  },
  {
    id: 8,
    name: 'Filtre',
    image: 'https://scdn.autodoc.de/catalog/categories/600x600/10105.png',
    subcategories: ['Filtre à carburant', 'Filtre à air', 'Filtre à huile', 'Filtre d\'habitacle']
  },
  {
    id: 9,
    name: 'Carrosserie',
    image: 'https://scdn.autodoc.de/catalog/categories/600x600/10101.png',
    subcategories: ['Phare avant', 'Rétroviseur', 'Feu arrière']
  },
  {
    id: 10,
    name: 'Huiles et fluides',
    image: 'https://scdn.autodoc.de/catalog/categories/600x600/10435.png',
    subcategories: ['Huile moteur']
  },
  {
    id: 11,
    name: 'Electricité',
    image: 'https://scdn.autodoc.de/catalog/categories/600x600/10110.png',
    subcategories: ['Alternateur', 'Batterie', 'Démarreur']
  }
];

export const accessories = [
  {
    id: 1,
    name: 'Accessoires voiture',
    image: 'https://scdn.autodoc.de/catalog/categories/300x300/33000.png',
    items: ['Tapis en caoutchouc', 'Tapis de voiture sur mesure', 'Enjoliveurs', 'Housses de siège auto']
  },
  {
    id: 2,
    name: 'Produits de nettoyage',
    image: 'https://scdn.autodoc.de/catalog/categories/300x300/30000.png',
    items: ['Nettoyant frein', 'Nettoyant pour FAP', 'Peinture voiture', 'Nettoyant pour moteur']
  },
  {
    id: 3,
    name: 'Outillage & équipement',
    image: 'https://scdn.autodoc.de/catalog/categories/300x300/36000.png',
    items: ['Clé dynamométrique', 'Jeu de douilles', 'Chandelles pour voiture', 'Clé pour filtre à huile']
  }
];

export const bestSellers = [
  {
    id: 1,
    brand: 'TRW',
    name: 'Amortisseur',
    ref: 'JGT286T',
    type: 'Pression de gaz, Amortisseur télescopique, TWIN',
    originalPrice: 94.62,
    price: 23.99,
    discount: 74,
    rating: 4.5,
    reviews: 63,
    image: 'https://cdn.autodoc.de/thumb?id=7142888&m=0&n=0&lng=fr&rev=94077971'
  },
  {
    id: 2,
    brand: 'GH',
    name: 'Jambe de force',
    ref: 'GH-354710C03',
    type: 'Essieu avant, droit, gauche',
    originalPrice: null,
    price: 131.99,
    discount: null,
    rating: 4.3,
    reviews: 3,
    image: 'https://media.autodoc.de/360_photos/17569191/h-preview.jpg'
  },
  {
    id: 3,
    brand: 'FEBI BILSTEIN',
    name: 'Disque de frein',
    ref: '43954',
    type: 'Essieu avant, 294x22mm, perforé/ventilé',
    originalPrice: 125.28,
    price: 46.99,
    discount: 62,
    rating: 4.4,
    reviews: 9,
    image: 'https://media.autodoc.de/360_photos/9745558/h-preview.jpg'
  },
  {
    id: 4,
    brand: 'LuK',
    name: 'Kit d\'embrayage',
    ref: '600 0355 00',
    type: 'avec butée hydraulique, avec volant moteur',
    originalPrice: 2021.89,
    price: 618.50,
    discount: 69,
    rating: 4.7,
    reviews: 21,
    image: 'https://cdn.autodoc.de/thumb?id=18365572&m=0&n=0&lng=fr&rev=94077971'
  },
  {
    id: 5,
    brand: 'FEBI BILSTEIN',
    name: 'Kit de distribution + pompe à eau',
    ref: '173132',
    type: 'avec pompe à eau, Nbr. dents: 129',
    originalPrice: 96.62,
    price: 39.99,
    discount: 58,
    rating: 4.2,
    reviews: 2,
    image: 'https://cdn.autodoc.de/thumb?id=16428492&m=0&n=0&lng=fr&rev=94077971'
  },
  {
    id: 6,
    brand: 'GATES',
    name: 'Kit de distribution',
    ref: 'K01T360HOB',
    type: 'PowerGrip',
    originalPrice: 216.60,
    price: 86.49,
    discount: 60,
    rating: 4.6,
    reviews: 17,
    image: 'https://media.autodoc.de/360_photos/15245009/h-preview.jpg'
  },
  {
    id: 7,
    brand: 'BOSCH',
    name: 'Plaquettes de frein',
    ref: '0 986 494 235',
    type: 'Low-Metallic',
    originalPrice: null,
    price: 32.99,
    discount: null,
    rating: 4.8,
    reviews: 78,
    image: 'https://media.autodoc.de/360_photos/1167850/h-preview.jpg'
  },
  {
    id: 8,
    brand: 'DAYCO',
    name: 'Kit de distribution + pompe à eau',
    ref: 'KTBWP7880',
    type: '',
    originalPrice: 270.70,
    price: 163.99,
    discount: 39,
    rating: 4.5,
    reviews: 57,
    image: 'https://media.autodoc.de/360_photos/7547950/h-preview.jpg'
  }
];

export const articles = [
  {
    id: 1,
    title: '5w30 et 5w40 : quelles sont les différences et laquelle choisir ?',
    description: 'Les performances du système de lubrification affectent directement la durée de vie du moteur.',
    date: '01 Jun 2023',
    image: 'https://cdn.autodoc.de/uploads/info_section/article/82/1744959556_8505_5a94a293bc427c15ea4a14a3e6647bea.jpeg'
  },
  {
    id: 2,
    title: 'Comment choisir ses plaquettes de frein : quelle qualité, quelle marque ?',
    description: 'Les plaquettes de frein sont des éléments essentiels du système de freinage.',
    date: '15 May 2023',
    image: 'https://cdn.autodoc.de/uploads/info_section/article/4/1763562812_5788_b23609c9bf753ace2730d426e9935261.jpeg'
  },
  {
    id: 3,
    title: 'Surchauffe des disques de frein : symptômes les plus fréquents',
    description: 'Surchauffe des disques de frein : symptômes, températures normales et solutions.',
    date: '01 Jun 2023',
    image: 'https://cdn.autodoc.de/uploads/info_section/article/3/1706109809_7403_30d442e9bb6403102fe68de11bf09f4d.jpeg'
  }
];


export const manufacturers = [
  'BOSCH', 'VALEO', 'TRW', 'SACHS', 'LuK', 'FEBI BILSTEIN', 
  'MAPCO', 'STARK', 'RIDEX', 'TOPRAN', 'METZGER', 'SWAG',
  'SKF', 'DAYCO', 'GATES', 'CONTINENTAL', 'INA', 'FAG'
];
